import type { FaireProductEntity } from "../../entity_types/product";

export const p_7zfmcchmgy: FaireProductEntity = {
  token: "p_7zfmcchmgy",
  type: "product",
  name: "Large Capacity Commuter Tote Bag Set Stylish Shoulder Bag",
  brandToken: "b_999ccmmbkw",
  brandName: "Halcyon Outfitters®",
  imageUrl:
    "https://cdn.faire.com/fastly/9b096245d153a34f62a7a872b3724607b6b33f34326ecfb1ad85781671e463e3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32430fdae2d26837199c891cf1f8875988905bab7d2e927eac0d5cc4648b9f31.jpeg",
    "https://cdn.faire.com/fastly/96c03ed4ddd809d3158e354170c01f9255c9190202e974c60259a4314441f3c9.jpeg",
    "https://cdn.faire.com/fastly/25fe977083a6615e01ef2047b0c897cb24d3da4790c7cecd3651a891db3c88e0.jpeg",
    "https://cdn.faire.com/fastly/157b25662528f4f4f70b2c956d8c83a1e44710a45fb2cd7fe2a2e2cda1e1e0f1.jpeg",
    "https://cdn.faire.com/fastly/ac6395ef6b60ad2019ca8bccd26bc49251d28945147795530fb6855ff9107f1a.jpeg",
    "https://cdn.faire.com/fastly/557aa0f12ac8c6f45dc96831e3eed1b10c216d2ed78b4e118b3245ff9f7433a4.jpeg",
    "https://cdn.faire.com/fastly/50eb5a0f9cff7e0858ddb3cdffb97f36a85b7df0781c8583828d4185d58d070d.jpeg",
    "https://cdn.faire.com/fastly/3fac42e3a2d8c8ac7227a3a3c3e293000931a591c8e4187e7315747cf628430f.jpeg",
  ],
  priceDollars: 6.45,
  description:
    "This versatile tote bag set is perfect for everyday use, featuring a sleek and modern design that complements urban lifestyles.\nMaterials: PU leather Inner Lining: None Bag Size: Medium Hardness: Soft Popular Elements: Stitched Details Separate Compartments: Yes Colors Available: Black, Light Brown, Coffee, Khaki Style: Urban Minimalist Closure Type: Zipper Internal Structure: Phone Pocket Strap: Single Strap \nExperience the perfect blend of style and functionality with this large capacity commuter tote bag set. Ideal for carrying your daily essentials, it features a trendy and minimalist design. This bag set is constructed from durable PU leather and has a soft structure that adds to its comfort and usability. The thoughtful design includes a separate phone pocket and a secure zipper closure, making it convenient for daily errands or casual outings.\n",
  tags: [],
  msrpDollars: 12.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:12.767Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
